import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import {
  BILLING_REPORT_DETAIL_PATH,
  NEW_BILLING_REPORT_DETAIL_PATH,
} from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { BILLING_REPORT_DETAIL_COLUMNS } from '../../../../config/columns';
import {
  clearBillingReportDetails,
  getBillingReportDetails,
} from '../../../../actions';

export const BillReportDetails = ({
  breadcrumbs,
  billingReportDetails,
  loading,
  dispatchGetBillingReportDetails,
  dispatchClearBillingReportDetails,
}) => {
  useLayoutEffect(() => () => dispatchClearBillingReportDetails(), []);

  const data = billingReportDetails.get('content') || [];
  const pages = billingReportDetails.get('totalPages') || null;
  const defaultPageSize = billingReportDetails.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Registro de Ventas e Ingresos"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_BILLING_REPORT_DETAIL_PATH}
      tableStructure={{
        columns: BILLING_REPORT_DETAIL_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetBillingReportDetails,
        modelPath: BILLING_REPORT_DETAIL_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetBillingReportDetails: getBillingReportDetails,
  dispatchClearBillingReportDetails: clearBillingReportDetails,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Ventas e Ingresos Detallados',
      href: BILLING_REPORT_DETAIL_PATH,
    },
  ],
  billingReportDetails: AccountingUnit.Billing.getIn([
    'detail',
    'all',
    'content',
  ]),
  loading: AccountingUnit.Billing.getIn(['detail', 'all', 'loading']),
});

BillReportDetails.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  billingReportDetails: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetBillingReportDetails: PropTypes.func.isRequired,
  dispatchClearBillingReportDetails: PropTypes.func.isRequired,
};

BillReportDetails.defaultProps = {
  billingReportDetails: null,
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(BillReportDetails);
